import React, { useEffect, useState } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import jwtEncode from "jwt-encode";
import DownloadMeta from "../Layout/DownloadMeta";

export const EventDetails = ({ setCurrentTab, event, type }) => {
  const sameDay = moment(event.startTime).format("MMMM Do YYYY") === moment(event.endTime).format("MMMM Do YYYY");
  const userData = useSelector((state) => state.userSlice);
  const isLoggedIn = userData.token.length > 0 ? true : false;
  const [authorized, setAuthorized] = useState(false);
  const configSlice = useSelector((state) => state.configSlice);
  const { config } = configSlice;
  const { user } = userData;
  const triggerLogin = () => {
    try {
      const payload = {
        origin: window.location.origin,
        redirectUri: window.location.pathname,
      };
      const token = jwtEncode(payload, "");
      return (window.location.href = `${config.redirectUri}?referrer=${token}`);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (event.type === "PRIVATE") {
      const isParticipant = event.users.filter((a) => a.id === user.uuid).length ? true : false;
      const isOrganizer = event.organizerId === user.uuid;
      if (isParticipant || isOrganizer) setAuthorized(true);
      else setCurrentTab("unauthorized");
    }
  }, []);

  const [metaPop, setMetaPop] = useState(false);

  return (
    <>
      <div className="event-detail">
        <span className="event-name">{event.name}</span>

        {type === "event" && (
          <span className="event-time">
            {moment(event.startTime).format("MMMM Do YYYY, h:mm A")} -{" "}
            {moment(event.endTime).format(!sameDay ? "MMMM Do YYYY, h:mm A" : "h:mm A")}
          </span>
        )}

        <span className="event-des">{event.description}</span>

        {event.type === "PUBLIC" || authorized ? (
          type === "environment" ? (
            <>
              {event?.platform["web"] ? (
                <>
                  <span className="action-btn" onClick={() => setCurrentTab("avatar-selection")}>
                    Join Now
                  </span>
                </>
              ) : (
                <>
                  <span className="event-des">To experience this environment, download our launcher.</span>
                  <span className="action-btn mt-0" onClick={() => setMetaPop(true)}>
                    Download Now
                  </span>
                </>
              )}
            </>
          ) : type === "event" ? (
            <>
              {event?.platform["web"] ? (
                <>
                  <span className="action-btn" onClick={() => setCurrentTab("avatar-selection")}>
                    Join Now
                  </span>
                </>
              ) : (
                <>
                  <span className="event-des">To experience this environment, download our launcher.</span>
                  <span className="action-btn mt-0" onClick={() => setMetaPop(true)}>
                    Download Now
                  </span>
                </>
              )}
            </>
          ) : (
            <>
              <span className="event-des">To experience this environment, download our launcher.</span>
              <span className="action-btn mt-0" onClick={() => setMetaPop(true)}>
                Download Now
              </span>
            </>
          )
        ) : !isLoggedIn ? (
          <span className="action-btn" onClick={() => triggerLogin()}>
            Login to join
          </span>
        ) : null}
      </div>

      <DownloadMeta metaPop={metaPop} setMetaPop={setMetaPop} />
    </>
  );
};
